'use client';

import { ReactNode } from 'react';

import { Accordion } from 'lighthouse';

import { AttributeFilterTitle } from '../AttributeFilterTitle';

type AttributeFilterAccordionProps = {
    name: string;
    selectedCount?: number;
    expanded: boolean;
    onExpandedChange: (expanded: boolean) => void;
    children: ReactNode;
};

export const AttributeFilterAccordion = ({ name, selectedCount = 0, expanded, onExpandedChange, children }: AttributeFilterAccordionProps) => (
    <Accordion
        typographyProps={{ variant: 'subtitle1', component: 'div' }}
        accordionShadow='elevation1'
        accordionSummery={
            <span className='flex items-center gap-2'>
                <AttributeFilterTitle name={name} />
                {selectedCount > 0 ? (
                    <span
                        className='inline-flex min-h-5 min-w-5 items-center justify-center rounded-full bg-primary/15 px-1.5 text-xs font-semibold
                            text-primary'>
                        {selectedCount.toLocaleString('fa-IR')}
                    </span>
                ) : null}
            </span>
        }
        expanded={expanded}
        onChange={(_, nextExpanded) => onExpandedChange(nextExpanded)}
        component='div'
        sx={{
            '&::before': {
                display: 'none'
            }
        }}>
        <div className='px-1 pb-2'>{children}</div>
    </Accordion>
);
